var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5e5299a7aa8e5e859096d764fbfd073864182c1f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["can-you-unlock@can-you-unlock"]={id:"5e5299a7aa8e5e859096d764fbfd073864182c1f"};
      